import script from "./ShareStockShop.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShareStockShop.vue?vue&type=script&setup=true&lang=ts"

import "./ShareStockShop.vue?vue&type=style&index=0&id=438873bc&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-438873bc"]])

export default __exports__